import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult, } from "../../../assets/utils/lib";
import { LookupDto, ReferenceDto, ReferenceGridDto, SearchReferenceDto } from "../../dto";

export class ReferenceClient extends BaseClient {
  routes = ["pophub", "Reference"];

  async getReferenceAsync(id: string | undefined): Promise<ReferenceDto> {
    const actions: string[] = ["GetReference"];
    const params: ApiParams[] = [new ApiParams("referenceId", id, true)];

    const result: ReferenceDto = await this.getAsync<ReferenceDto>(
      actions,
      params
    );
    return result;
  }

  async getAllCommunityReferencesAsync(
    communityId: string
  ): Promise<ReferenceDto[]> {
    const actions: string[] = ["GetAllCommunityReferences"];
    const params: ApiParams[] = [
      new ApiParams("communityId", communityId, true),
    ];

    const result: ReferenceDto[] = await this.getAsync<ReferenceDto[]>(
      actions,
      params
    );
    return result;
  }

  async searchReferenceAsync(
    payload: SearchReferenceDto | undefined
  ): Promise<IPagedResult<ReferenceGridDto>> {
    const actions: string[] = ["GetReferences"];
    const result: IPagedResult<ReferenceGridDto> = await this.postAsync<
      SearchReferenceDto,
      ReferenceGridDto,
      IPagedResult<ReferenceGridDto>
    >(actions, payload);
    return result;
  }

  async saveReferenceAsync(
    payload: ReferenceDto | undefined
  ): Promise<IActionResult<ReferenceDto>> {
    const actions: string[] = ["SaveReference"];
    return await this.postAsync<ReferenceDto>(actions, payload);
  }

  async deleteReferenceAsync(
    id?: string | undefined
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeleteReference"];
    const params: ApiParams[] = [new ApiParams("referenceId", id, true)];
    return await this.deleteAsync(actions, params);
  }

  async getLookupsAsync(): Promise<{
    communities: LookupDto[];
    pageLink: LookupDto[];
  }> {
    const actions: string[] = ["GetLookups"];
    const result: { communities: LookupDto[]; pageLink: LookupDto[] } =
      await this.getAsync<{ communities: LookupDto[]; pageLink: LookupDto[] }>(
        actions,
        []
      );
    return result;
  }
}
